<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 报告用章新增表单 -->
      <el-form
        ref="addReportForm1"
        :rules="rules"
        :model="addReportForm"
        v-if="showForm==='showFormClearAdd'"
        label-position="right"
        label-width="160px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" v-else>

              <!-- 在本地搜索 -->
              <!-- <el-select
                style="width:100%"
                v-model="addReportForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select> -->

              <!-- 远程搜索 -->
<el-select
                style="width:100%"
                v-model="addReportForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>


            </el-form-item>
            <!-- 是否公示 / 是否告知（选择项目后展示，只读，不可手动选择） -->
            <el-form-item label="是否公示" v-if="hasProjectSelected">
              <span
                style="color:#666;font-size:16px"
              >{{addReportForm.is_announce=='1'?'是':'否'}}</span>    <div style="color:rgb(245, 95, 95);margin-bottom:15px;margin-left:20px;font-size:12px">
          *如果否，请提示黄欢锋公示存档
        </div>
            </el-form-item>
            <el-form-item label="是否告知" v-if="hasProjectSelected">
              <span
                style="color:#666;font-size:16px"
              >{{addReportForm.is_notify=='1'?'是':'否'}}</span><div style="color:rgb(245, 95, 95);margin-bottom:15px;margin-left:20px;font-size:12px">
          *如果否，请提示项目相关业务补充告知书
        </div>
            </el-form-item>
            <!-- 项目编号 -->
            <!-- <el-form-item label="项目编号" style="margin-bottom:0">
                <span>{{selectProjectNum}}</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">用章信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
              v-if="addReportForm.top_content"
            >{{addReportForm.top_content}}</div>

            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addReportForm.member">
              <span
                v-if="addReportForm.member"
                style="color:#666;font-size:16px"
              >{{addReportForm.member.nickname}}</span>
            </el-form-item>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="$store.state.process.admin.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addReportForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.admin.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 印章类别 -->
            <!-- <el-form-item label="印章类别" style="margin-bottom:0px;">
              <el-radio-group v-model="addReportForm.seal_type" :disabled="draftDisable">
                <el-radio label="1">公章</el-radio>
                <el-radio label="2">法人章</el-radio>
                <el-radio label="3">合同专用章</el-radio>
                <el-radio label="4">报告专用章</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <!-- 印章类型 -->
            <el-form-item label="印章类型" style="margin-bottom:0px;">
              <el-radio-group v-model="addReportForm.seal_sub_type" :disabled="draftDisable">
                <el-radio label="1">送审版</el-radio>
                <el-radio label="2">备案版</el-radio>
              </el-radio-group>
            </el-form-item>
              <!-- 份数 -->
            <el-form-item label="份数">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入份数"
                type="number"
                v-model="addReportForm.num"
              ></el-input>
            </el-form-item>
            <!-- 送审版报告 -->
            <el-form-item label="送审版报告" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="breportList"
                :detailsImgList="breportDetails"
                @my-upload-change="handleBreportUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备案版报告 -->
            <el-form-item label="备案版报告" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="areportList"
                :detailsImgList="areportDetails"
                @my-upload-change="handleAreportUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 现场照片 -->
            <el-form-item label="现场照片" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="sceneList"
                :detailsImgList="sceneDetails"
                @my-upload-change="handleSceneUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 过控文件 -->
            <el-form-item label="过控文件" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="controlList"
                :detailsImgList="controlDetails"
                @my-upload-change="handleControlUploadChange"
              ></upload-file>
            </el-form-item>
          
            <!-- 项目名称 -->
            <!-- <el-form-item label="项目名称">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入项目名称"
                v-model="addReportForm.business_name"
              ></el-input>
            </el-form-item>-->
            <!-- 附件 -->
            <el-form-item label="其他附件" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addReportForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 报告用章审批表单 -->
      <el-form
        ref="addReportForm2"
        :rules="rules"
        :model="addReportForm"
        v-if="showForm==='showFormClearHandle'"
        label-position="left"
        label-width="160px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addReportForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('report',addReportForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addReportForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('report',addReportForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addReportForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <el-select
                style="width:100%"
                v-model="addReportForm.project_id"
                filterable
                v-if="addReportForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                v-for="(items,index) in addReportForm.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addReportForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name}}</span>
              </span>
            </el-form-item>
            <!-- 是否公示 / 是否告知（选择项目后展示，只读，不可手动选择） -->
            <el-form-item label="是否公示" v-if="hasProjectSelected">
              <span
                style="color:#666;font-size:16px"
              >{{addReportForm.is_announce=='1'?'是':'否'}}</span>
            </el-form-item>
            <el-form-item label="是否告知" v-if="hasProjectSelected">
              <span
                style="color:#666;font-size:16px"
              >{{addReportForm.is_notify=='1'?'是':'否'}}</span>
            </el-form-item>
            <!-- 项目编号 -->
            <!-- <el-form-item label="项目编号" style="margin-bottom:10px">
                <span style="color:#666;font-size:16px">{{selectProjectNum}}</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">用章信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
              v-if="addReportForm.top_content"
            >{{addReportForm.top_content}}</div>
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addReportForm.member">
              <span
                v-if="addReportForm.member"
                style="color:#666;font-size:16px"
              >{{addReportForm.member.nickname}}</span>
            </el-form-item>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="addReportForm.is_edit=='1' && $store.state.process.admin.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addReportForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.admin.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 印章类别 -->
            <!-- <el-form-item label="印章类别" style="margin-bottom:0px;">
              <el-radio-group v-model="addReportForm.seal_type" v-if="addReportForm.is_edit=='1'">
                <el-radio label="1">公章</el-radio>
                <el-radio label="2">法人章</el-radio>
                <el-radio label="3">合同专用章</el-radio>
                <el-radio label="4">报告专用章</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addReportForm.seal_type=='1'">公章</span>
                <span v-if="addReportForm.seal_type=='2'">法人章</span>
                <span v-if="addReportForm.seal_type=='3'">合同专用章</span>
                <span v-if="addReportForm.seal_type=='4'">报告专用章</span>
              </span>
            </el-form-item> -->
            <!-- 印章类型 -->
            <el-form-item label="印章类型" style="margin-bottom:0px;">
              <el-radio-group
                v-model="addReportForm.seal_sub_type"
                v-if="addReportForm.is_edit=='1'"
              >
                <el-radio label="1">送审版</el-radio>
                <el-radio label="2">备案版</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addReportForm.seal_sub_type=='1'">送审版</span>
                <span v-if="addReportForm.seal_sub_type=='2'">备案版</span>
              </span>
            </el-form-item>
            <!-- 份数 -->
            <el-form-item label="份数" style="margin-bottom:0px;">
              <el-input
                placeholder="请输入份数"
                v-if="addReportForm.is_edit=='1'"
                v-model="addReportForm.num"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addReportForm.num}}</span>
            </el-form-item>
            <!-- 送审版报告 -->
            <el-form-item label="送审版报告" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="addReportForm.is_edit=='1'"
                :imgList="breportList"
                :detailsImgList="breportDetails"
                @my-upload-change="handleBreportUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备案版报告 -->
            <el-form-item label="备案版报告" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="addReportForm.is_edit=='1'"
                :imgList="areportList"
                :detailsImgList="areportDetails"
                @my-upload-change="handleAreportUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 现场照片 -->
            <el-form-item label="现场照片" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="addReportForm.is_edit=='1'"
                :imgList="sceneList"
                :detailsImgList="sceneDetails"
                @my-upload-change="handleSceneUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 过控文件 -->
            <el-form-item label="过控文件" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="addReportForm.is_edit=='1'"
                :imgList="controlList"
                :detailsImgList="controlDetails"
                @my-upload-change="handleControlUploadChange"
              ></upload-file>
            </el-form-item>
            
            <!-- 项目名称 -->
            <!-- <el-form-item label="项目名称" style="margin-bottom:0px;">
              <el-input
                placeholder="请输入项目名称"
                v-if="addReportForm.is_edit=='1'"
                v-model="addReportForm.business_name"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addReportForm.business_name}}</span>
            </el-form-item>-->
            <!-- 附件 -->
            <el-form-item label="其他附件" style="margin-bottom:10px">
              <upload-file
                style="width:100%"
                :isSubmit="addReportForm.is_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                v-if="addReportForm.is_edit=='1'"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addReportForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addReportForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addReportForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 报告用章新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormClearAdd' && addReportForm.is_draft!='1'"
        @click="handleAddSettlementSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormClearAdd' && addReportForm.is_draft!='1'"
        @click="handleAddSettlementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 报告用章申请编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormClearAdd' && addReportForm.is_draft=='1' && !draftDisable"
        @click="handleEditSettlementSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormClearAdd' && addReportForm.is_draft=='1' && !draftDisable"
        @click="handleEditSettlementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 报告用章申请重新提交按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormClearHandle' && addReportForm.is_edit=='1'"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormClearHandle' && addReportForm.is_edit=='1'"
        @click="handleEditSettlementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addReportForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addReportForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addReportForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addReportForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width:95%" label="审批备注" v-if="addReportForm.approval_status=='1'">
              <el-input placeholder="审批备注" type="textarea" v-model="approvalRemark"></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addReportForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1','report',addReportForm.id)"
          :disabled="disableLimit"
          v-if="addReportForm.approval_status=='1'"
          style="background:#f4a029;"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1','report',addReportForm.id)"
          :disabled="disableLimit"
          v-if="addReportForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import UploadFile from '../../../components/UploadFile'
import SignDialog from '../../../components/SignDialog'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      approveVisible: false,

      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,

      imgList: [],
      detailsImgList: [],

      // 报告用章新增字段附件列表
      breportList: [],
      breportDetails: [],
      areportList: [],
      areportDetails: [],
      sceneList: [],
      sceneDetails: [],
      controlList: [],
      controlDetails: [],
      // 用户主动上传过的 URL 集合，用于「选项目时保留手动上传、丢弃接口返回旧项」
      breportUserUrls: new Set(),
      areportUserUrls: new Set(),
      sceneUserUrls: new Set(),
      controlUserUrls: new Set(),

      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      tiemID1: null,
      timeDou: 100,
      // 新增报告用章
      addReportForm: {
        remark: '',
        annex: '',
        project_id: [],
        seal_type: '1',
        // 印章类型：1送审版 2备案版
        seal_sub_type: '1',
        // 送审版报告 / 备案版报告 / 现场照片 / 过控文件
        breport_file: '',
        areport_file: '',
        scene_photo: '',
        control_file: '',
        // 是否公示 / 是否告知（由项目接口返回，只读）
        is_announce: '',
        is_notify: '',
        num: 1,
        business_name: '',
      },
      approvalRemark: '',
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },
    }
  },
  props: [],
  components: {
    UploadFile,
    SignDialog,
  },
  watch: {
    '$store.state.process.admin.formData'(newval, olval) {
      this.addReportForm = newval
    },
    '$store.state.process.admin.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addReportForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    // 送审版报告
    'addReportForm.breport_file': {
      handler: function (val, oldVal) {
        this.breportList = val || []
        this.breportDetails = val || []
      },
    },
    // 备案版报告
    'addReportForm.areport_file': {
      handler: function (val, oldVal) {
        this.areportList = val || []
        this.areportDetails = val || []
      },
    },
    // 现场照片
    'addReportForm.scene_photo': {
      handler: function (val, oldVal) {
        this.sceneList = val || []
        this.sceneDetails = val || []
      },
    },
        // 过控文件
    'addReportForm.control_file': {
      handler: function (val, oldVal) {
        this.controlList = val || []
        this.controlDetails = val || []
      },
    },
    // 项目名称变化：新增态下，「清空非手动上传」已搬到 handleProjectSelectChange1 同步执行；
    // watch 仅作为兜底 —— 当 val 在 addReportForm 里的项目 ID 真正发生切换时，
    // 主动跑一次 fetchNotifyByProjectId（应对非 el-select 路径改写 project_id 的场景）
    'addReportForm.project_id': {
      handler: function (val, oldVal) {
        const newPid = (val && val[0]) || ''
        if (this.showForm === 'showFormClearAdd' && newPid) {
          const oldPid = (oldVal && oldVal[0]) || ''
          // 仅当 oldVal 与 newPid 不一致时（如初次 []→[id]、[id1]→[id2]）触发 fetch
          if (oldPid !== newPid) {
            // fetchNotifyByProjectId 内部用 _notifySeq 防竞态；这里不再 $set 文件字段
            this.fetchNotifyByProjectId(newPid)
          }
        }
      },
    },
    // 默认驳回节点是当前节点
    'addReportForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
        } else {
          this.k_code = ''
        }
      },
    },
  },
  methods: {
 // 按搜索条件查找，不在本地进行查找
 async projectSearch(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
     
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/admin/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },


    ...mapMutations('process/admin', ['getDialogVisible', 'userFilter']),
    projectFilter(query = '') {
      let arr = this.projectList.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/admin/setprojectListSub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/admin/setprojectListSub', arr)
      }
    },
    handleProjectSelectBlur1(val) {
      if (!val) {
        if (this.projectList.length > this.moreNum) {
          this.$store.commit(
            'process/admin/setprojectListSub',
            this.projectList.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/admin/setprojectListSub',
            this.projectList
          )
        }

        console.log('this.projectListSub', this.projectListSub)
      }
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    jiesuanChangeClick() {
      if (this.addArrivalForm.is_settle == '1') {
        this.addArrivalForm.is_settlement = '1'
      }
    },

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }

      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }

      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *编辑报告用章审批提交
    async handleEditSettlementSubmit(val) {
      if (this.$store.state.process.admin.list3.length > 0) {
        // 判断是不是草稿
        if (this.addReportForm.is_draft == '1') {
          this.$refs.addReportForm1.validate(async (valid) => {})
        } else {
          this.$refs.addReportForm2.validate(async (valid) => {})
        }
      }

      this.disableLimit = true
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addReportForm.id)

        param.append('remark', this.addReportForm.remark)

        // 多选
        // param.append('project_id', this.addReportForm.project_id.join(','))
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addReportForm.project_id.join(','))
        }

        param.append('annex', JSON.stringify(this.imgList))

        param.append('seal_type', this.addReportForm.seal_type)
        param.append('seal_sub_type', this.addReportForm.seal_sub_type)
        param.append('breport_file', JSON.stringify(this.breportList))
        param.append('areport_file', JSON.stringify(this.areportList))
        param.append('scene_photo', JSON.stringify(this.sceneList))
        param.append('control_file', JSON.stringify(this.controlList))
        param.append('num', this.addReportForm.num)
        // param.append('business_name', this.addReportForm.business_name)

        param.append('preset_member', this.addReportForm.preset_member)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/report_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }

        this.getDialogVisible(false)
      }, this.timeDou)
    },
    // *报告用章审批新增点击提交
    async handleAddSettlementSubmit(val) {
      if (this.$store.state.process.admin.list3.length > 0) {
        this.$refs.addReportForm1.validate(async (valid) => {
          //   如果校验失败
          // if (valid == false) return this.$message.error('角色信息不合规')
          // 如果校验成功
        })
      }

      this.disableLimit = true
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('remark', this.addReportForm.remark)

        // 多选
        // param.append('project_id', this.addReportForm.project_id.join(','))
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addReportForm.project_id.join(','))
        }

        param.append('annex', JSON.stringify(this.imgList))

        param.append('seal_type', this.addReportForm.seal_type)
        param.append('seal_sub_type', this.addReportForm.seal_sub_type)
        param.append('breport_file', JSON.stringify(this.breportList))
        param.append('areport_file', JSON.stringify(this.areportList))
        param.append('scene_photo', JSON.stringify(this.sceneList))
        param.append('control_file', JSON.stringify(this.controlList))
        param.append('num', this.addReportForm.num)
        // param.append('business_name', this.addReportForm.business_name)

        param.append('preset_member', this.addReportForm.preset_member)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/report_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }

        this.getDialogVisible(false)
      }, this.timeDou)
    },
    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/admin/getReportList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/admin/getReportList')
      }
    },
    // 选择项目名称1
    async handleProjectSelectChange1(val) {
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addReportForm.project_id = [val[0]]
      }
      // ★ 同步先清空「非手动上传」的文件，再发起 fetch。
      // 否则 watch 'addReportForm.project_id' 的 nextTick 清空可能晚于 fetchNotifyByProjectId 内的 $set，
      // 导致「第一次选项目」4 文件被二次清空看不见；切换别的项目再切回来才正常。
      this.clearNonUserFiles()
      // 选择项目后查询「是否公示/是否告知」，未选择则隐藏
      const projectId =
        this.addReportForm.project_id && this.addReportForm.project_id.length > 0
          ? this.addReportForm.project_id[0]
          : ''
      this.fetchNotifyByProjectId(projectId)
      // 强制刷新组件
      this.$forceUpdate()
    },
    // 清空 4 个附件字段里「非用户手动上传」的项（保留 userUrls 中的），
    // 由 handleProjectSelectChange1 在 fetch 之前同步调用；watch 中的同名清空已移除，避免时序冲突
    clearNonUserFiles() {
      if (this.showForm !== 'showFormClearAdd') return
      const filterKeep = (list, set) => (list || []).filter((i) => set.has(i.url))
      this.$set(
        this.addReportForm,
        'breport_file',
        filterKeep(this.addReportForm.breport_file, this.breportUserUrls)
      )
      this.$set(
        this.addReportForm,
        'areport_file',
        filterKeep(this.addReportForm.areport_file, this.areportUserUrls)
      )
      this.$set(
        this.addReportForm,
        'scene_photo',
        filterKeep(this.addReportForm.scene_photo, this.sceneUserUrls)
      )
      this.$set(
        this.addReportForm,
        'control_file',
        filterKeep(this.addReportForm.control_file, this.controlUserUrls)
      )
    },
    // 查询项目是否公示/是否告知（只读展示），并按项目回填 4 个附件字段
    // 注意：4 个附件字段仅在「新增」态按接口返回值自动填充（编辑态保留详情接口已加载的值）
    async fetchNotifyByProjectId(projectId) {
      // 请求序号：来回切换项目时，旧请求可能晚返回覆盖新值，
      // 用 seq 自增保证只有最后一次调用的结果才赋值
      const seq = (this._notifySeq = (this._notifySeq || 0) + 1)
      // 仅「新增」态（showFormClearAdd）才用项目级接口回填 4 个文件字段
      const isAddMode = this.showForm === 'showFormClearAdd'
      if (!projectId) {
        this.$set(this.addReportForm, 'is_announce', '')
        this.$set(this.addReportForm, 'is_notify', '')
        if (isAddMode) {
          this.$set(this.addReportForm, 'breport_file', [])
          this.$set(this.addReportForm, 'areport_file', [])
          this.$set(this.addReportForm, 'scene_photo', [])
          this.$set(this.addReportForm, 'control_file', [])
        }
        return
      }
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // 传参方式参考财务-报销：project_id 用 [id] 数组包一层
      param.append('project_id', `[${projectId}]`)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/get_notify_by_project_id',
        data: param,
      })
      // 期间又发起了新的请求（seq 不再最大），丢弃本次结果
      if (seq !== this._notifySeq) return

      // 真实返回结构：res.datas = { is_announce, is_notify, breport_file, areport_file, scene_photo, control_file, msg }
      // 不在这里 return：即便利 res.code 不是 200，只要 datas 里带值也要展示
      if (res.code != 200 && res.datas && res.datas.msg) {
        this.$message.error(res.datas.msg)
      }
      console.log(
        '[ReportForm] get_notify_by_project_id res (seq=' + seq + ')',
        'isAddMode =',
        isAddMode,
        res
      )
      const datas = res.datas || {}
      // 调试：把接口返回的 datas 完整打出来，下次用户测可以确认 breport_file 等字段是否存在
      console.log(
        '[ReportForm] get_notify_by_project_id datas =',
        JSON.stringify(datas),
        'isAddMode =',
        isAddMode
      )
      // 1) 是否公示 / 是否告知（只读，编辑态也展示）
      this.$set(
        this.addReportForm,
        'is_announce',
        this.normalizeYesNo(datas.is_announce)
      )
      this.$set(
        this.addReportForm,
        'is_notify',
        this.normalizeYesNo(datas.is_notify)
      )
      // 2) 4 个附件字段：仅新增态按接口返回填入（watch project_id 已经把"接口返回旧项"清掉，
      //    留下的是用户手动上传的；这里追加接口返回的新项并按 URL 去重）
      if (isAddMode) {
        this.$set(
          this.addReportForm,
          'breport_file',
          this.mergeApiFiles(
            this.addReportForm.breport_file,
            datas.breport_file
          )
        )
        this.$set(
          this.addReportForm,
          'areport_file',
          this.mergeApiFiles(
            this.addReportForm.areport_file,
            datas.areport_file
          )
        )
        this.$set(
          this.addReportForm,
          'scene_photo',
          this.mergeApiFiles(
            this.addReportForm.scene_photo,
            datas.scene_photo
          )
        )
        this.$set(
          this.addReportForm,
          'control_file',
          this.mergeApiFiles(
            this.addReportForm.control_file,
            datas.control_file
          )
        )
      }
    },
    // 把接口返回的项拼到现有 list 后面（按 URL 去重，避免重复）
    mergeApiFiles(oldList, newFilesVal) {
      const oldArr = oldList || []
      const newArr = this.parseFiles(newFilesVal)
      if (newArr.length === 0) return oldArr
      const existingUrls = new Set(oldArr.map((i) => i.url))
      const toAdd = newArr.filter((i) => !existingUrls.has(i.url))
      return toAdd.length === 0 ? oldArr : oldArr.concat(toAdd)
    },
    // 统一 1/0/'1'/'0' 等值，空值返回 ''
    normalizeYesNo(val) {
      if (val === undefined || val === null || val === '') return ''
      return String(val)
    },
    // 解析接口返回的文件字段：可能是数组，也可能是 JSON 字符串，统一为「upload-file 期望的 {name,type,url} 对象数组」
    parseFiles(val) {
      let raw = []
      if (val == null) return []
      if (Array.isArray(val)) raw = val
      else if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val)
          raw = Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      } else {
        return []
      }
      // 把每一项都规整成 {name,type,url}，兼容「字符串数组」「{path/...}」等情况
      return raw
        .map((item) => this.normalizeFileItem(item))
        .filter((i) => i && i.url)
    },
    // 把任意形态的文件项规整成 {name,type,url}
    normalizeFileItem(item) {
      if (item == null) return null
      if (typeof item === 'string') {
        const url = item
        const lastSlash = url.lastIndexOf('/')
        const name = lastSlash >= 0 ? url.slice(lastSlash + 1) : url
        const lastDot = name.lastIndexOf('.')
        const type = lastDot >= 0 ? name.slice(lastDot + 1) : 'file'
        return { name, type, url }
      }
      if (typeof item === 'object') {
        const url =
          item.url ||
          item.file_url ||
          item.path ||
          item.file_path ||
          item.src ||
          item.href ||
          ''
        if (!url) return null
        const name = item.name || url.slice(url.lastIndexOf('/') + 1)
        const type =
          item.type ||
          (name.indexOf('.') >= 0 ? name.split('.').pop() : 'file')
        return { name, type, url }
      }
      return null
    },
    // 合并旧值与接口返回值（追加到后面），保证多次切换/重复填充时已有文件不被覆盖
    mergeFiles(oldVal, newVal) {
      const oldArr = this.parseFiles(oldVal)
      const newArr = this.parseFiles(newVal)
      return oldArr.concat(newArr)
    },
    // 送审版报告上传变更
    handleBreportUploadChange(data) {
      this.syncUserUrls(this.breportUserUrls, this.breportList, data)
      this.breportList = data
    },
    // 备案版报告上传变更
    handleAreportUploadChange(data) {
      this.syncUserUrls(this.areportUserUrls, this.areportList, data)
      this.areportList = data
    },
    // 现场照片上传变更
    handleSceneUploadChange(data) {
      this.syncUserUrls(this.sceneUserUrls, this.sceneList, data)
      this.sceneList = data
    },
    // 过控文件上传变更
    handleControlUploadChange(data) {
      this.syncUserUrls(this.controlUserUrls, this.controlList, data)
      this.controlList = data
    },
    // 同步用户上传过的 URL 集合：把新上传的加入集合、把删除的从集合移除
    syncUserUrls(userUrlsSet, oldList, newList) {
      const oldUrls = new Set((oldList || []).map((i) => i.url))
      const newUrls = new Set((newList || []).map((i) => i.url))
      newUrls.forEach((url) => {
        if (!oldUrls.has(url)) userUrlsSet.add(url)
      })
      oldUrls.forEach((url) => {
        if (!newUrls.has(url)) userUrlsSet.delete(url)
      })
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },

  async created() {
    this.addReportForm = JSON.parse(
      JSON.stringify(this.$store.state.process.admin.formData)
    )
    if (this.addReportForm.annex) {
      this.imgList = this.addReportForm.annex
      this.detailsImgList = this.addReportForm.annex
    }
    // 回填新增字段的附件列表
    if (this.addReportForm.breport_file) {
      this.breportList = this.addReportForm.breport_file
      this.breportDetails = this.addReportForm.breport_file
    }
    if (this.addReportForm.areport_file) {
      this.areportList = this.addReportForm.areport_file
      this.areportDetails = this.addReportForm.areport_file
    }
    if (this.addReportForm.scene_photo) {
      this.sceneList = this.addReportForm.scene_photo
      this.sceneDetails = this.addReportForm.scene_photo
    }
    if (this.addReportForm.control_file) {
      this.controlList = this.addReportForm.control_file
      this.controlDetails = this.addReportForm.control_file
    }
    console.log('this.addReportForm.is_edit', this.addReportForm.is_edit)
    this.disableLimit = false
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    // 已选择项目时，查询「是否公示/是否告知」
    const selectedProjectId = this.$store.state.process.finance.isFromProjectBar
      ? this.$store.state.process.finance.projectId
      : this.addReportForm.project_id && this.addReportForm.project_id.length > 0
      ? this.addReportForm.project_id[0]
      : ''
    if (selectedProjectId) {
      this.fetchNotifyByProjectId(selectedProjectId)
    }
  },
  mounted() {},
  computed: {
    ...mapState('process/admin', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
    // 是否已选择项目（决定「是否公示/是否告知」是否展示）
    hasProjectSelected() {
      if (this.$store.state.process.finance.isFromProjectBar) return true
      if (
        this.addReportForm.project_id &&
        this.addReportForm.project_id.length > 0
      ) {
        return true
      }
      if (
        this.addReportForm.project_list &&
        this.addReportForm.project_list.length > 0
      ) {
        return true
      }
      return false
    },
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>